export default {
  "PICKING_APP_VIEW": "PICKING_APP_VIEW"
} as any